module.exports = __webpack_public_path__ + "img/settings.8288eeb6.png";